let interactedTimeout;

export default {
    namespaced: true,
    state: () => {
        return {
            interacted: false,
            videoStarted: false,
            videoFinished: false,
            videoPaused: false,
            ivsMode: false,
            fullScreen: false,
            showPresentationLayoutControls: false,
            externalFullscreen: false,
        }
    },
    getters: {},
    mutations: {
        setInteracted: (state, payload) => state.interacted = payload,
        setVideoStarted: (state, payload) => state.videoStarted = payload,
        setVideoFinished: (state, payload) => state.videoFinished = payload,
        setVideoPaused: (state, payload) => state.videoPaused = payload,
        setIvsMode: (state, payload) => state.ivsMode = payload,
        setFullscreen: (state, payload) => state.fullScreen = payload,
        setExternalFullscreen: (state, payload) => state.externalFullscreen = payload,
        showPresentationLayoutControls: state => state.showPresentationLayoutControls = true,
        hidePresentationLayoutControls: state => state.showPresentationLayoutControls = false,
    },
    actions: {
        interact: ({commit}) => {
            setTimeout(() => {
                commit('setInteracted', true);
            }, 0);
            clearTimeout(interactedTimeout);
            interactedTimeout = setTimeout(() => {
                commit('setInteracted', false);
                commit('hidePresentationLayoutControls');
            }, 1500);
        }
    }
}